import './helpers/ensureSingleKrispSdk.js';
import { preloadVapiWebRtc } from './helpers/preloadVapiWebRtc.js';
import './index.scss';
import { createScene } from './setScene';

preloadVapiWebRtc();
